var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNoConnection = function SvgNoConnection(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 144,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#no-connection_svg__a)",
    fillRule: "evenodd",
    d: "M93.845 36.013c-29.642-7.386-62.31.508-85.485 23.682a7.5 7.5 0 0 0 10.607 10.607C35.9 53.367 58.919 46.224 80.986 48.872zM68.95 60.909c-14.963.727-29.716 6.804-41.143 18.232a5 5 0 0 0 7.07 7.07C41.213 79.877 48.764 75.5 56.78 73.08zM85.54 72.602l7.966-7.966c8.279 3.027 16.045 7.862 22.688 14.505a5 5 0 1 1-7.071 7.07c-6.776-6.775-14.944-11.312-23.583-13.61M63.618 94.524l11.097-11.097a39.85 39.85 0 0 1 25.569 11.624 5 5 0 1 1-7.07 7.071c-8.013-8.013-19.431-10.545-29.596-7.598m39.466-39.466 11.199-11.199a90 90 0 0 1 21.356 15.836 7.5 7.5 0 0 1-10.606 10.607 74.8 74.8 0 0 0-21.949-15.244",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#no-connection_svg__b)",
    strokeLinecap: "round",
    strokeWidth: 8,
    d: "m116 28-88 88"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-connection_svg__a",
    x1: 72,
    x2: 72,
    y1: 33.335,
    y2: 103.586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07818C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D3E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "no-connection_svg__b",
    x1: 72,
    x2: 72,
    y1: 28,
    y2: 116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07818C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17D3E5"
  })))));
};
export default SvgNoConnection;